var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAllColors(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 40,
    viewBox: "0 0 68 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 20C32 10.0589 40.0589 2 50 2V2C59.9411 2 68 10.0589 68 20V20C68 29.9411 59.9411 38 50 38V38C40.0589 38 32 29.9411 32 20V20Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 37.5C40.335 37.5 32.5 29.665 32.5 20C32.5 10.335 40.335 2.5 50 2.5C59.665 2.5 67.5 10.335 67.5 20C67.5 29.665 59.665 37.5 50 37.5Z",
    stroke: "black",
    strokeOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.25 20C25.25 30.3553 33.6447 38.75 44 38.75C54.3553 38.75 62.75 30.3553 62.75 20C62.75 9.64466 54.3553 1.25 44 1.25C33.6447 1.25 25.25 9.64466 25.25 20Z",
    fill: "#ACB4BE",
    stroke: "white",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 20C19.25 30.3553 27.6447 38.75 38 38.75C48.3553 38.75 56.75 30.3553 56.75 20C56.75 9.64466 48.3553 1.25 38 1.25C27.6447 1.25 19.25 9.64466 19.25 20Z",
    fill: "#008E7D",
    stroke: "white",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 20C13.25 30.3553 21.6447 38.75 32 38.75C42.3553 38.75 50.75 30.3553 50.75 20C50.75 9.64466 42.3553 1.25 32 1.25C21.6447 1.25 13.25 9.64466 13.25 20Z",
    fill: "#C17B28",
    stroke: "white",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 20C7.25 30.3553 15.6447 38.75 26 38.75C36.3553 38.75 44.75 30.3553 44.75 20C44.75 9.64466 36.3553 1.25 26 1.25C15.6447 1.25 7.25 9.64466 7.25 20Z",
    fill: "#EBD3D4",
    stroke: "white",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 20C1.25 30.3553 9.64466 38.75 20 38.75C30.3553 38.75 38.75 30.3553 38.75 20C38.75 9.64466 30.3553 1.25 20 1.25C9.64466 1.25 1.25 9.64466 1.25 20Z",
    fill: "#282C37",
    stroke: "white",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllColors);
export default __webpack_public_path__ + "static/media/all-colors.0bee2c0382f37945f3c2acfb4e67e7dd.svg";
export { ForwardRef as ReactComponent };